import tippy, { type Instance } from 'tippy.js';

tippy.setDefaultProps({
  arrow: true,
  animation: 'fade',
  duration: [100, 200],
  theme: 'cobot',
});

let tippyInstances: Instance[] = [];

export default function enableTippy() {
  tippyInstances.forEach((instance) => {
    instance.destroy();
  });
  tippyInstances = [];

  Array.from(
    document.querySelectorAll(
      '[data-tippy]:not([data-white-bg-tippy])',
    ) as NodeListOf<HTMLElement>,
  ).forEach(function (el: HTMLElement) {
    enableTippyForElement(el, tippyInstances);
  });
  Array.from(
    document.querySelectorAll(
      '[data-white-bg-tippy]',
    ) as NodeListOf<HTMLElement>,
  ).forEach(function (el: HTMLElement) {
    enableTippyForElement(el, tippyInstances, {
      theme: 'white-background',
      allowHTML: true,
      interactive: true,
      trigger: 'click',
      onTrigger: function (_instance, event: Event) {
        event.stopPropagation();
        event.preventDefault();
      },
    });
  });
}

function enableTippyForElement(
  el: HTMLElement,
  tippyInstances: Instance[],
  options?: Parameters<typeof tippy>[1],
) {
  const content = el.dataset.tippy;
  if (content) {
    // Check if element is inside a popover
    const popover = el.closest('[popover]');
    const appendTo = popover || document.body;

    const instance = tippy(el, {
      content,
      appendTo,
      ...options,
    });
    tippyInstances.push(instance);
  }
}
